import styled from 'styled-components';
import { IconButton } from '@mui/material';

export const CustomIconButton = styled(IconButton)`
  position: absolute;
  top: 10px;
  right: 5px;
  color: ${({ theme: { palette } }) => palette.primary.dark};
`;
